export default "__VITE_ASSET__C_ZFM5Sc__"